module.exports = __webpack_public_path__ + "static/img/1.7b70d4c.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/2/3/sp/1.png
// module id = 3jvj
// module chunks = 0